import { useContext } from 'react';
import HistoryEventsContext from '../contexts/HistoryEventsContext';

export default function useHistoryEventsContext() {
  return useContext(HistoryEventsContext);
}
